<template>
  <!-- 姓名欄位標題：標題＋輸入格式／必填標籤＋填寫範例（切版 my-KYC-v4.html、personal-data.html 的 .name-field-label） -->
  <label class="name-field-label">
    <span class="name-label-text">{{ field.label }}</span>
    <span class="name-field-meta">
      <small v-if="field.format" class="field-format">{{ field.format }}</small>
      <small class="field-required" :class="{ 'is-optional': !required }">
        {{ required ? $t('Bao.field_required') : $t('Bao.field_optional') }}
      </small>
    </span>
    <small v-if="field.example" class="field-example">{{ $t('Bao.input_example') }}{{ field.example }}</small>
  </label>
</template>

<script>
export default {
  name: 'NameFieldLabel',
  props: {
    // getNameFields() 回傳的單一欄位 { label, format, example }
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: true
    }
  }
}
</script>
